<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
      Campaign Stats
    </h3>
    <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Total Subscribers
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.totalSubscribers }}
            </dd>
          </dl>
        </div>
      </div>

      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Sent
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.sentSubscribers }}
            </dd>
          </dl>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Failed
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.failedSubscribers }}
            </dd>
          </dl>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg relative">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt
              class="text-sm leading-5 font-medium text-gray-500 truncate flex items-center"
            >
              Orders Generated
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-gray-500 hover:text-gray-700 cursor-pointer ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                @mouseenter="showPopover = true"
                @mouseleave="showPopover = false"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              <div
                v-if="showPopover"
                class="absolute z-10  px-2 py-1 -mt-1 text-sm bg-gray-700 text-white rounded shadow-lg"
                style="white-space: break-spaces;"
              >
                Orders placed by customers within 7 days of receiving the
                campaign message
              </div>
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              <span v-if="isLoading">
                <Spinner />
              </span>
              <span v-else>
                {{ orders.length }}
              </span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Total Order value from the campaign
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              <span v-if="isLoading">
                <Spinner />
              </span>
              <span v-else>{{ totalOrderValue }}</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <div
      class="mt-5 bg-white overflow-hidden shadow rounded-lg"
      v-if="template"
    >
      <div class="px-4 py-5 sm:p-6">
        <h4 class="text-lg leading-6 font-medium text-gray-900">
          Message
        </h4>
        <p class="mt-2 text-sm text-gray-600">{{ template.message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
  components: {
    Spinner
  },
  data() {
    return {
      report: {},
      template: null,
      orders: [],
      showPopover: false,
      totalOrderValue: 0,
      isLoading: false
    };
  },
  created() {
    const campaignId = this.$route.params.campaignId;
    this.$store
      .dispatch("Marketing/getCampaignReport", { campaignId })
      .then(response => {
        this.report = response.report;
        this.template = response.template;
      });
    this.getOrderReport();
  },
  methods: {
    getOrderReport() {
      this.isLoading = true;
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("Marketing/getOrderStats", { campaignId })
        .then(response => {
          this.isLoading = false;
          console.log("response", response);
          this.orders = response.orderStats.orderNumbers;
          if (response.orderStats.orderNumbers.length > 0) {
            this.totalOrderValue = response.orderStats.totalPrice;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
